<div class="lightContent">
    <div class="headingPage">
      <h2 class="tablinks all_stories"  (click)="showAllStory = true;showCrossTenant = false;showMobile = false; showMy = false;showMyWorkSpace = false;showPixabay=false;openTabs('internal')"
      [class]="showAllStory ? 'active' : ' '" id="defaultOpen">Internal</h2>
      <h2 class="tablinks my_workspace"  (click)="showAllStory = false; showCrossTenant = false; showMobile = false;showMyWorkSpace = true;showMy = true;showPixabay=false; openTabs('wires')" [class]="showMyWorkSpace ? 'active' : ' '"  id="wire" >Wires</h2>
      <h2 class="tablinks my_workspace" *ngIf="domainWiseImageList" (click)="showAllStory = false;showMyWorkSpace = false;showMy = false; showCrossTenant = true; showMobile = false;showPixabay=false; openTabs('cross-tenant')" [class]="showCrossTenant ? 'active' : ' '"  id="allDomain" >Cross-Tenant</h2>
      <h2 class="tablinks my_workspace" *ngIf="isMobile91Enabled" (click)="showAllStory = false;showMyWorkSpace = false;showMy = false; showCrossTenant = false; showMobile = true;showPixabay=false; openTabs('mobile91')" [class]="showMobile ? 'active' : ' '"  id="allDomain" >Mobile91</h2>
      <h2 class="tablinks my_workspace" *ngIf="enablePixabay" (click)="showAllStory = false;showMyWorkSpace = false;showMy = false; showCrossTenant = false; showMobile = false;showPixabay=true;openTabs('pixabay')" [class]="showPixabay ? 'active' : ' '"  id="pixabay" >Pixabay</h2>
    </div>
    <div id="allStories" [style.display] = "showAllStory ? 'block' : 'none'" style="display: block;" *ngIf="showAllStory">
      <div class="imageLibrary">
          <div class="listing"
            [pageId]="'photoListing'"
            [allApi]="'photolist'"
            [searchApi]="'photolist'"
            [metaApi]="'photo_meta'"
            [ImageArray]="listImageArray"
            (sendListIdToParentfn)="sendImageIdToParent($event)"
            photoListing="true"
            [showPagination]="false"
            [photogallery]="showPhotogallery"
            (sendToClearImageList) = "setClearList($event)"
            [imageSearch]="true"
            (sendIdToParentfn)="sendIdToParent($event)"
            [exclusionList]="exclusionList"
            search_label="Search Photo Library...">
          </div>
      </div>
    </div>
    <div class="pageContainer tabcontent" id="myWorkspace" [style.display] = "showPixabay ? 'block' : 'none'"  *ngIf="showPixabay">
      <div class="imagelist2">
          <div class="imageLibrary">
          <div class="listing"
          [pageId]="'pixabayListing'"
          [allApi]="'pixabaylist'"
          [searchApi]="'pixabaylist_search'"
          [ImageArray]="listImageArray"
          (sendListIdToParentfn)="sendImageIdToParent($event)"
          photoListing="true"
          [showPagination]="false"
          [photogallery]="showPhotogallery"
          (sendToClearImageList) = "setClearList($event)"
          (sendIdToParentfn)="sendIdToParent($event)"
          search_label="Search Photos...">
        </div>
        </div>
      </div>
    </div>
    <div class="pageContainer tabcontent" id="myWorkspace" [style.display] = "showMyWorkSpace ? 'block' : 'none'"  *ngIf="showMy">
      <div class="imagelist2">
          <div class="imageLibrary">
          <div class="listing"
          [pageId]="'wirephotoListing'"
          [allApi]="'wirephotolist'"
          [searchApi]="'wiresearch_photo'"
          [metaApi]="'wirephoto_meta'"
          [ImageArray]="listImageArray"
          (sendListIdToParentfn)="sendImageIdToParent($event)"
          photoListing="true"
          [showPagination]="false"
          [photogallery]="showPhotogallery"
          (sendToClearImageList) = "setClearList($event)"
          [imageSearch]="true"
          (sendIdToParentfn)="sendIdToParent($event)"
          search_label="Search Wire Photos...">
        </div>
        </div>
      </div>
    </div>
    <div id="allStories" [style.display] = "showCrossTenant ? 'block' : 'none'" style="display: block;" *ngIf="showCrossTenant">
      <div class="imageLibrary">
          <div class="listing"
            [pageId]="'photoListing'"
            [allApi]="'photolist'"
            [searchApi]="'photolist'"
            [metaApi]="'photo_meta'"
            [ImageArray]="listImageArray"
            (sendListIdToParentfn)="sendImageIdToParent($event)"
            photoListing="true"
            [imageSearch]="true"
            [showPagination]="false"
            [photogallery]="showPhotogallery"
            (sendToClearImageList) = "setClearList($event)"
            (sendIdToParentfn)="sendIdToParent($event)"
            [exclusionList]="exclusionList"
            search_label="Search Photo Library..."
            [domainWiseImageList]="domainWiseImageList"
            >
          </div>
      </div>
    </div>
    <div class="pageContainer tabcontent" id="myWorkspace" [style.display] = "showMobile ? 'block' : 'none'"  *ngIf="showMobile">
      <div class="imagelist2">
          <div class="imageLibrary">
          <div class="listing"
          [pageId]="'mobile91Listing'"
          [allApi]="'mobile91'"
          [searchApi]="'mobile91'"
          [metaApi]="'mobile91_meta'"
          [imageSearch]="true"
          [ImageArray]="listImageArray"
          (sendListIdToParentfn)="sendImageIdToParent($event)"
          photoListing="true"
          [showPagination]="false"
          [photogallery]="showPhotogallery"
          (sendToClearImageList) = "setClearList($event)"
          (sendIdToParentfn)="sendIdToParent($event)"
          search_label="Search Mobile91 Photos...">
        </div>
        </div>
      </div>
    </div>
  </div>

